import { render, staticRenderFns } from "./PublicHolidayDeleteDialog.vue?vue&type=template&id=26810690&scoped=true"
import script from "./PublicHolidayDeleteDialog.vue?vue&type=script&lang=js"
export * from "./PublicHolidayDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./PublicHolidayDeleteDialog.vue?vue&type=style&index=0&id=26810690&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26810690",
  null
  
)

export default component.exports